(ns ncr.fragment.props.estimates-dialog
  (:require
   [clojure.string :as str]
   [clojure.core.async :refer [go]]
   [react]
   [uix.core.alpha :as uix]
   [uix.hooks.alpha]
   [tick.core :as t]
   [ncr.etc.pf :as pf]
   [ncr.etc.modal :as modal]
   [ncr.widgets.inline-edit :as ie]
   [ncr.fragment.props.money.input :as mi]
   [ncr.widgets.pf :as pfw]
   [ncr.widgets.core :as w]
   [ncr.fragment.props.date :as props-date]))

(defn- date-format [^js date]
  (props-date/to-string (t/date date)))

(defn- date-parse [date-str]
  (when-not (str/blank? date-str)
    (try
      (t/inst (t/at (t/parse-date date-str props-date/formatter) "00:00"))
      (catch js/Error _ nil))))

(defn c-interval [{:keys [labels merge-in interval-delete]} flow-ix interval-ix {:keys [violations] :as interval}]
  (let [merge-in (partial merge-in flow-ix interval-ix)]
    (letfn
      [(option-by-id [options id]
         (some #(and (= (:id %) id) %) options))]
      [pf/c-data-list-item {:class-name :ncr-c-estimate__interval}
       [pf/c-data-list-item-row
        [pf/c-data-list-item-cells {}
         [pf/c-data-list-cell {:width 1}
          [ie/c-inline-edit
           {:value (:about interval)
            :on-edit-commit
            (fn [s _]
              (when-not (str/blank? s)
                (merge-in {:about (str/trim s)})
                true))}]]

         [pf/c-data-list-cell {:width 5}
          [pf/c-split {:has-gutter true :is-wrappable true}
           [pf/c-split-item {:class-name :ncr-c-estimate__interval-value}
            (let [{:keys [brutto netto]} interval]
              [mi/c-inline-input-netto-brutto
               {:netto netto
                :brutto brutto
                :ignore-missing? true
                :validated (not (contains? violations :netto-brutto))
                :display-type :input-group
                :display-brutto :absolute
                :display-netto :absolute
                :on-change
                (fn [{:keys [brutto netto]}]
                  (go
                    (merge-in {:brutto brutto :netto netto})))}])]

           [pf/c-split-item {:class-name :ncr-c-estimate__interval-direction}
            (let [options [{:id "income" :label "Income"} {:id "expense" :label "Expense"}]]
              [pfw/c-pf-select
               {:variant :single
                :max-height "200px"
                :selections (option-by-id options (:direction interval))
                :on-select
                (fn [_ s _]
                  (merge-in {:direction (get s :id)}))}
               options])]

           [pf/c-split-item {:class-name :ncr-c-estimate__interval-start-date}
            [pf/c-date-picker
             (merge
               {:value
                (if-let [value (:start-date interval)]
                  (date-format value) "")

                :class-name
                (when (contains? violations :start-date)
                  :ncr-m-error)

                :date-parse date-parse
                :date-format date-format
                :placeholder "Start date"
                :append-to #(.-body js/document)
                :on-change
                (fn [_event v _date]
                  (merge-in {:start-date (date-parse v)}))})]]

           [pf/c-split-item {:class-name :ncr-c-estimate__interval-end-date}
            [pf/c-date-picker
             {:value
              (if-let [date (:end-date interval)]
                (date-format date) "")

              :date-parse date-parse
              :date-format date-format
              :placeholder "End date"
              :append-to #(.-body js/document)
              :on-change
              (fn [_event v _date]
                (merge-in {:end-date (date-parse v)}))}]]

           [pf/c-split-item {:class-name :ncr-c-estimate__interval-period}
            (let
              [options
               [{:id "day" :label "Daily"}
                {:id "week" :label "Weekly"}
                {:id "month" :label "Monthly"}
                {:id "year" :label "Yearly"}
                {:id "period" :label "Period"}]]

              [pfw/c-pf-select
               {:variant :single
                :max-height "250px"
                :selections
                (option-by-id options (:per interval))
                :on-select
                (fn [_ s _]
                  (merge-in {:per (:id s)}))}
               options])]

           [pf/c-split-item {:class-name :ncr-c-estimate__interval-step}
            (let [value (or (-> interval :step) 1)]
              [pf/c-number-input
               {:min 1
                :max 12
                :value value
                :width-chars 2
                :is-disabled (= "period" (:per interval))
                :on-change (fn [^js e] (merge-in {:step (js/Number.parseFloat (.. e -target -value))}))
                :on-plus #(merge-in {:step (inc value)})
                :on-minus #(merge-in {:step (dec value)})}])]

           [pf/c-split-item {:class-name :ncr-c-estimate__interval-label}
            [pfw/c-pf-select
             {:validated
              (when (contains? violations :label) :error)
              :variant :typeahead
              :max-height "250px"
              :class :ncr-estimate-flow-interval-select
              :menu-append-to #(.-body js/document)
              :placeholder-text "Label"
              :position :right
              :label-fn #(when % (str "#" (:name %)))
              :selections
              (option-by-id labels (:label interval))
              :on-select
              (fn [_ s _]
                (merge-in {:label (:id s)}))}
             (->> labels
               (sort-by :name)
               (map
                 (fn [label]
                   (assoc label :render-fn
                     (fn [{:keys [value]}]
                       [[:span.ncr-pf-c-select-option-label-truncated (:label value)]])))))]]]]

         [pf/c-data-list-action
          [pf/c-dropdown-menu
           {:dropdown-items
            [[pf/c-dropdown-item
              {:icon [w/c-menu-icon {:icon :tag-multiple-outline}]
               :on-click
               #(interval-delete flow-ix interval-ix)}
              "Delete"]]}]]]]])))

(defn c-flow [{:keys [merge-in flow-delete interval-add] :as props} flow-ix flow]
  [:<>
   [pf/c-panel {:class-name :ncr-c-estimate__flow}
    [pf/c-panel-header {:class-name :ncr-c-estimate__flow-header}
     [pf/c-split
      [pf/c-split-item {:is-filled true}
       [ie/c-inline-edit
        (let [title (:title flow)]
          {:value title
           :on-edit-commit
           (fn [s _]
             (when-not (str/blank? s)
               (merge-in flow-ix {:title s})
               true))})]]
      [pf/c-split-item {:class-name :pf-u-mr-lg}
       [pf/c-dropdown-menu
        {:dropdown-items
         [[pf/c-dropdown-item
           {:icon [w/c-menu-icon {:icon :plus}]
            :on-click
            #(interval-add flow-ix)}
           "Add Interval"]

          [pf/c-dropdown-item
           {:icon [w/c-menu-icon {:icon :minus}]
            :on-click
            #(flow-delete flow-ix)}
           "Delete Flow"]]}]]]]

    [pf/c-panel-main {:class-name :ncr-c-estimate__flow-main}
     [pf/c-panel-main-body
      [pf/c-data-list {:is-compact true :class-name :ncr-c-estimate__flow-list}
       (map-indexed
         (fn [ix interval]
           ^{:key ix}
           [c-interval props flow-ix ix interval])
         (:intervals flow))]]]]
   [pf/c-divider]])

(defn- c-toolbar [{:keys [flow-add undo]}]
  [pf/c-toolbar {:class [:pf-u-p-0 :pf-u-m-0]}
   [pf/c-toolbar-content
    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :plus
       :tooltip "Add Flow"
       :on-click
       (fn [_]
         (flow-add))}]]
    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :undo
       :tooltip "Undo"
       :is-disabled (nil? undo)
       :on-click
       (fn [_]
         (undo))}]]]])

(defn c-flows-editor [props flows]
  [pf/c-stack
   [pf/c-stack-item
    [c-toolbar props]]
   [pf/c-stack-item {:class-name :ncr-c-estimate :is-filled true :style {:overflow :auto}}
    (map-indexed
      (fn [ix flow]
        ^{:key ix}
        [c-flow props
         ix flow])
      flows)]])

(defn c-edit-dialog [{:keys [labels title save! operations validated flows]}]
  (let [updating? (uix/state false)]
    [modal/c-modal
     {:title title
      :width "110rem"
      :id :estimate-props-modal
      :is-overflow-visible true
      :actions
      [[pf/c-button
        {:variant :primary
         :is-disabled (or @updating? (not validated))
         :on-click
         (fn []
           (reset! updating? true)
           (go
             (let [status (<! (save! "Estimate: [modified]"))]
               (reset! updating? false)
               (if (not= :error status)
                 (modal/close! nil)))))}
        "Ok"]
       [pf/c-button
        {:variant :link
         :is-disabled @updating?
         :on-click #(modal/close! nil)}
        "Cancel"]]}
     [c-flows-editor
      (merge {:labels labels} operations)
      flows]]))